import { SCRAPER_REQ_FIELD_KEY } from './field-const';

// Common Field list by category
export const CommonFieldList: SCRAPER_REQ_FIELD_KEY[] = [];

export const CommerceReviewFieldList: SCRAPER_REQ_FIELD_KEY[] = [
  ...CommonFieldList,
  SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE,
  SCRAPER_REQ_FIELD_KEY.BRAND,
  SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME,
  SCRAPER_REQ_FIELD_KEY.LINK,
];

export const SocialMediaFieldList: SCRAPER_REQ_FIELD_KEY[] = [
  ...CommonFieldList,
];

export const CommunityFieldList: SCRAPER_REQ_FIELD_KEY[] = [...CommonFieldList];

// definition field는 keyword의 noise filter 역할을 한다
export const KeywordDefinitionFieldList = [
  SCRAPER_REQ_FIELD_KEY.KEYWORD,
  SCRAPER_REQ_FIELD_KEY.DEFINITION,
] as const;
